import { orchestrator } from 'satcheljs';
import {
    timeStreamProjectCreated,
    openTimeStreamProject,
    closeCurrentTimeStreamProject,
} from '../actions';
import hasSelectedProject from '../selectors/hasSelectedProject';
import getProjectId from '../utils/getProjectId';
import getTenantAndMailbox from '../utils/getTenantAndMailbox';

orchestrator(timeStreamProjectCreated, ({ targetMailbox, outlookSpace }) => {
    const { tenant, mailbox } = getTenantAndMailbox(targetMailbox);
    if (hasSelectedProject()) {
        closeCurrentTimeStreamProject();
    }
    openTimeStreamProject(getProjectId(tenant, mailbox, outlookSpace.id));
});
